import { HttpClient } from '@angular/common/http';
import {
    Injectable,
    Injector,
} from '@angular/core';
import { ILicense } from '@models';
import { MapperService } from '@services/mapper.service';

import { BaseLicenseService } from 'main/app-state/current-user/license/base-license.service';

@Injectable({
    providedIn: 'root',
})
export class TenantLicenseService extends BaseLicenseService<ILicense> {
    protected _endpoint = '/odata/Settings';
    protected _getEndpoint = '/odata/Settings/UiPath.Server.Configuration.OData.GetLicense';

    constructor(
        http: HttpClient,
        protected _injector: Injector,
    ) {
        super(http, MapperService.licenseMap, _injector);
    }

    public deleteLicense() {
        return this._http.post(`${this._endpoint}/UiPath.Server.Configuration.OData.DeleteLicense()`, null);
    }
}
